export const SLOT_MACHINE_SPEED = 300
export const SPEED_CHANGE_THRESHOLD_1 = 30
export const SPEED_CHANGE_THRESHOLD = 5
export const SLOWDOWN_FACTOR_SMALL = 0.99
export const SLOWDOWN_FACTOR = 0.95

export const TIMER_INTERVAL = 100
